import { render, staticRenderFns } from "./Parcelamentos.vue?vue&type=template&id=93215c2c&"
import script from "./Parcelamentos.vue?vue&type=script&lang=js&"
export * from "./Parcelamentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports